import { render, staticRenderFns } from "./SecSafety_SKMG14.vue?vue&type=template&id=63903512&scoped=true&"
import script from "./SecSafety_SKMG14.vue?vue&type=script&lang=js&"
export * from "./SecSafety_SKMG14.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety_SKMG14.vue?vue&type=style&index=0&id=63903512&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63903512",
  null
  
)

export default component.exports